import React, {useState, useMemo, useEffect} from 'react'
import _ from 'lodash'

import {IconButton, Popover} from '@material-ui/core'
import './PopGroupPicker.scss'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'

const PopGroupPicker = ({
  options = [],
  loading = false,
  open,
  value,
  onClickOption,
  onClose,
  anchorEl,
}) => {
  const handleClose = e => {
    if (onClose) {
      onClose(e)
    }
  }

  const handleClickOption = (e, t) => {
    if (onClickOption) {
      onClickOption(e, t)
    }
    if (onClose) {
      onClose(e)
    }
  }

  const selectedIndex = !!value ? options.findIndex(o => o.id === value.id) : -1

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      classes={{
        paper: 'c-pop-group-picker',
      }}
    >
      <div className="c-res-mod ap-list ap-scrollbar" style={{maxHeight: 116, padding: '11px 0'}}>
        <div className="ap-list__wrapper" style={{padding: '0 8px'}}>
          {loading && <LoadingIndicator />}
          {!loading && options.length === 0 && (
            <div
              className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-group-picker__option`}
            >
              No groups found
            </div>
          )}
          {options.map((o, i) => (
            <div
              key={i}
              className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-group-picker__option
               ${selectedIndex === i ? 'c-pop-group-picker__option--selected' : ''}`}
              style={{cursor: 'pointer'}}
              onClick={e => handleClickOption(e, o)}
            >
              {o.name}
            </div>
          ))}
        </div>
      </div>
    </Popover>
  )
}

export default PopGroupPicker
